import { FMSType, LocationVarKey } from "@swivl-mono/types";

import { IF_ANY, IS_EQUAL, IS_NOT_EQUAL, IS_TRUE } from "../../../../Components/Worksheets/Types/Worksheet.Interface";
import {
  DropdownRow,
  Indent,
  InputRow,
  MultiLineRow,
  PageHeader,
  Section,
  SectionHeader,
  SwitchRow,
  TextAreaRow,
  TextRow
} from "../../../../Components/Worksheets/WorksheetComponent/WorksheetComponents";
import { usePropertiesGetLocationIds } from "../../../../Hooks/usePropertiesGetLocationIds";

export const PAGE_KEYS: LocationVarKey[] = [
  LocationVarKey.VoiceHasAccountNumberIntegration,
  LocationVarKey.VoiceAccountNumberFound,
  LocationVarKey.VoiceSendAccountNumberTextFound,
  LocationVarKey.VoiceFoundAccountNumberText,
  LocationVarKey.VoiceAccountNumberNotFound,
  LocationVarKey.VoiceAccountNumberMessage,
  LocationVarKey.VoiceSendAccountNumberText,
  LocationVarKey.VoiceAccountNumberTextMessage,
  LocationVarKey.VoiceForwardAccountNumber,
  LocationVarKey.VoiceAccountNumberEscalateTo,
  LocationVarKey.VoiceAccountNumberPhoneNumber
];

export default function WorksheetView() {
  const page = usePropertiesGetLocationIds();
  return (
    <>
      <PageHeader {...page}>Account Number</PageHeader>
      <br></br>
      <SwitchRow
        {...page}
        keyName={LocationVarKey.VoiceHasAccountNumberIntegration}
        label="Use FMS to Lookup"
        hideIf={IF_ANY([IS_NOT_EQUAL(LocationVarKey.VoiceHasAccountNumber, "1"), IS_NOT_EQUAL(LocationVarKey.FMSType, FMSType.StorEdge)])}
      />

      <SectionHeader {...page} hideIf={IS_NOT_EQUAL(LocationVarKey.VoiceHasAccountNumberIntegration, "1")}>
        Account Number Found
      </SectionHeader>
      <TextAreaRow
        {...page}
        hideIf={IS_NOT_EQUAL(LocationVarKey.VoiceHasAccountNumberIntegration, "1")}
        marginTop
        label=" Voice Message"
        keyName={LocationVarKey.VoiceAccountNumberFound}
      />
      <SwitchRow
        {...page}
        keyName={LocationVarKey.VoiceSendAccountNumberTextFound}
        hideIf={IS_NOT_EQUAL(LocationVarKey.VoiceHasAccountNumberIntegration, "1")}
        label="Send SMS"
      />
      <TextAreaRow
        {...page}
        hideIf={IF_ANY([
          IS_NOT_EQUAL(LocationVarKey.VoiceSendAccountNumberTextFound, "1"),
          IS_NOT_EQUAL(LocationVarKey.VoiceHasAccountNumberIntegration, "1")
        ])}
        marginTop
        label=" SMS Message"
        keyName={LocationVarKey.VoiceFoundAccountNumberText}
      />
      <SectionHeader {...page} hideIf={IS_NOT_EQUAL(LocationVarKey.VoiceHasAccountNumberIntegration, "1")}>
        Account Number Not Found
      </SectionHeader>
      <TextAreaRow
        {...page}
        hideIf={IS_NOT_EQUAL(LocationVarKey.VoiceHasAccountNumberIntegration, "1")}
        marginTop
        label=" Voice Message 1"
        keyName={LocationVarKey.VoiceAccountNumberNotFound}
      />
      <TextAreaRow
        {...page}
        hideIf={IS_NOT_EQUAL(LocationVarKey.VoiceHasAccountNumberIntegration, "1")}
        marginTop
        label=" Voice Message 2"
        keyName={LocationVarKey.VoiceAccountNumberMessage}
      />
      <TextAreaRow
        {...page}
        hideIf={IS_EQUAL(LocationVarKey.VoiceHasAccountNumberIntegration, "1")}
        marginTop
        label=" Voice Message"
        keyName={LocationVarKey.VoiceAccountNumberMessage}
      />
      <SwitchRow {...page} keyName={LocationVarKey.VoiceSendAccountNumberText} label="Send SMS" />
      <TextAreaRow
        {...page}
        hideIf={IS_NOT_EQUAL(LocationVarKey.VoiceSendAccountNumberText, "1")}
        marginTop
        label=" SMS Message"
        keyName={LocationVarKey.VoiceAccountNumberTextMessage}
      />
      <SwitchRow {...page} keyName={LocationVarKey.VoiceForwardAccountNumber} label="Escalate" />
      <DropdownRow
        {...page}
        hideIf={IS_EQUAL(LocationVarKey.VoiceForwardAccountNumber, "0")}
        label="Send escalations to"
        marginTop
        keyName={LocationVarKey.VoiceAccountNumberEscalateTo}
        options={[
          { label: "swivl Conversations", value: "swivl" },
          { label: "External Phone Number", value: "phone" }
        ]}
      />

      <Section
        {...page}
        hideIf={IF_ANY([IS_NOT_EQUAL(LocationVarKey.VoiceForwardAccountNumber, "1"), IS_EQUAL(LocationVarKey.VoiceAccountNumberEscalateTo, "swivl")])}
      >
        <InputRow {...page} keyName={LocationVarKey.VoiceAccountNumberPhoneNumber} label="External Phone Number" />
        <div className="cortexDescription">
          This is the direct line defined{" "}
          <a
            href="/properties/page/cortex/voice/voice-settings"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "#FF5B02", textDecoration: "underline" }}
          >
            here
          </a>
          . Only overwrite this if you have a different direct line for this use case!
        </div>
      </Section>
    </>
  );
}
